import { useParams } from 'react-router-dom';
import NotFound from 'NotFound';
import Conversations from './Conversations';
import { EditChat } from './EditChat';

export function DynamicActionRouteHandler() {
  const { action } = useParams<{ action?: 'edit' | 'conversations' }>();

  switch (action) {
    case 'edit':
      return <EditChat />;
    case 'conversations':
      return <Conversations />;
    default:
      return <NotFound />;
  }
}
